import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';
import Subscription from '../../models/Subscription';
import { IResponse, GetIntegrationsOrishaTypologiesResponse } from '@leedpulse-monorepo/interfaces';

async function getOrishaCustomProspectTypes(
  subscription: Subscription,
  auth: Authentication
): Promise<GetIntegrationsOrishaTypologiesResponse> {
  try {
    const oResponse : IResponse<GetIntegrationsOrishaTypologiesResponse> = await HttpClient.get(`/integrations/orisha/typologies`, auth.token, {
      'x-api-key': subscription.apiKey,
    });

    return oResponse.data;
  } catch (e) {
    console.log('error: ', e);
    if (e instanceof TypeError && e.message === 'Failed to fetch') {
      throw new getOrishaCustomProspectTypesFailure('Le serveur ne répond pas');
    } else if (e instanceof Error) {
      throw new getOrishaCustomProspectTypesFailure(e.message);
    }
    throw new getOrishaCustomProspectTypesFailure('Unknown error');
  }
}

export class getOrishaCustomProspectTypesFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getOrishaCustomProspectTypes;
